import { Component } from '@angular/core';
import { MatBottomSheetRef } from '@angular/material/bottom-sheet';

@Component({
  selector: 'app-no-access-modal',
  templateUrl: './no-access-modal.component.html',
  styleUrls: ['./no-access-modal.component.scss']
})
export class NoAccessModalComponent {
  constructor(private bottomSheetRef: MatBottomSheetRef<NoAccessModalComponent>) {}

  close(): void {
    this.bottomSheetRef.dismiss();
  }
}
